import ajax from './cities/ajax'
import etobicoke from './cities/etobicoke'
import mississauga from './cities/mississauga'
import northYork from './cities/northYork'
import oakville from './cities/oakville'
import pickering from './cities/pickering'
import scarborough from './cities/scarborough'
import toronto from './cities/toronto'
import vaughan from './cities/vaughan'
import woodbridge from './cities/woodbridge'

export default {
  province: 'Ontario (GTA)',
  abbr: 'Ont.',
  alpha: 'ON',
  lawSociety: 'Law Society of Upper Canada',
  writeup: '',
  cities: [
    ajax,
    etobicoke,
    mississauga,
    northYork,
    oakville,
    pickering,
    scarborough,
    toronto,
    vaughan,
    woodbridge
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/index.js